import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

let now = +new Date();

// initial state
const state = {
    // GUI
    navExpanderOpen: false, // The Hamburger in mobile navigation menu

    // reference books
    /* global FRS_CAMPAIGN */
    campaign: {
        short_url: FRS_CAMPAIGN
    },
    catalog: {},
    countries: {},
    regions: {},

    marketing: {
        // DEBUG:
        /** /
        how_you_heard: 'news'
        /**/
    },

    // cart
    items: [
        // DEBUG:
        /** /
        {
            item_id: 268,
            children: { 269: 1, 270: 2 },
            gc: false,
            lines: [ 'LOREM IPSUM', 'DOLOR', 'SIT AMET' ],
            options: {
                location: 'l01'
            }
        },
        {
            item_id: 271,
            children: { 272: 3, 273: 4 },
            gc: true,
            lines: []
        }
        /**/
    ],
    isOrderCompleted: false,
    orderId: 0,

    // address handling structures
    billingAddressId: now,
    selectedAddressId: 0, // can be set to billing or another address ID depending on a value of shipTo flag
    addresses: {
        // default data for billing address
        [now]: {
            /**/
            first_name: '',
            middle_name: '',
            last_name: '',
            address1: '',
            address2: '',
            company: '',
            city: '',
            country: 'US',
            postal_code: '',
            state_prov: '',
            // additional
            phone: '',
            email: ''
            /**/
            // DEBUG:
            /** /
            first_name: 'Willy',
            middle_name: 'J',
            last_name: 'Wonka',
            address1: '111 main st',
            address2: '',
            company: 'WD',
            city: 'Nashville',
            country: 'US',
            postal_code: '37000',
            state_prov: 'TN',
            phone: '5551234567',
            email: 'vlad.klimko+wjw@gmail.com'
            /**/
        }
        // '1507110943866': addressObject,
        // DEBUG
        /** /
        '1507110945677': {
            first_name: 'Stephen',
            middle_name: 'E.',
            last_name: 'White',
            address1: '109 main st',
            address2: 'suite 302',
            company: 'WD',
            city: 'Bellville',
            country: 'US',
            postal_code: '44000',
            state_prov: 'OH'
        }
        /**/
    },
    creditCard: {
        types: {},
        yearNow: 1970,
        yearsCount: 15,
        monthes: [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ]
    },
    shipTo: 'ship2billing', // 'ship2another' // 'ship2multiple'
    // mapping each deliverable line item (or GC as a whole) to registered address ID
    addressMap: {
        // setIndex0_childId_positionIndex: addressId,
        // setIndex1_childId_positionIndex: addressId,

        // DEBUG
        /** /
        '0_269_0': '1507110945677',
        '0_270_0': '1507110945677',
        '0_270_1': '1507110945677',
        '1_271_g': '1507110945677'
        /**/
    }
}

// getters
const getters = {
    /**
     * Base products with ordered list of child products
     * @param state
     */
    products: state => state.catalog,

    /**
     * To provide a component with a data source in form of notation xxxx[prodId].children[childId]
     * @param state
     * @returns {*|state.catalog}
     */
    childProducts: function (state) {
        var cat = Object.assign({}, state.catalog);
        for (var pid in cat) {
            var newChildren = {};
            cat[pid].children.forEach(function (item) {
                var itemId = 'item_id' in item ? item.item_id : 0;
                if (itemId > 0) {
                    newChildren[itemId] = item;
                }
            });
            cat[pid].children = Object.assign({}, newChildren);
        }
        return cat;
    },

    /**
     * To provide a component with a list of all known dependent line items in notation xxxx[childId]
     * @param state
     * @returns {*|state.catalog}
     */
    baseProductChildren: function (state) {
        var output = {};
        for (var productItemId in state.catalog) {
            var children = state.catalog[productItemId]['children'] || [];
            for (var index in children) {
                if ('item_id' in children[index]) {
                    output[children[index]['item_id']] = {
                        item_id: children[index]['item_id'],
                        // parent_id: productItemId,
                        // price: children[index]['price'],
                        description: children[index]['description']
                    };
                }
            }
        }
        return output;
    },

    /**
      * Number of unique items in the shopping cart
      * @param state
     */
    cartItemsCount: state => state.isOrderCompleted ? 0 : state.items.length,

    /**
     * Shopping Cart
     * @param state
     */
    cart: state => state.items,
    isOrderCompleted: state => state.isOrderCompleted,
    countries: state => state.countries,
    regions: state => state.regions,

    marketing: state => state.marketing,

    // address/shipping related
    shipTo: state => state.shipTo,
    billing: state => state.addresses[state.billingAddressId],
    shippingAddresses: state => {
        var output = {};
        Object.keys(state.addresses).forEach(idx => {
            // console.log(idx, state.billingAddressId);
            if (idx.toString() !== state.billingAddressId.toString()) {
                output[idx] = state.addresses[idx];
            }
        });
        return output;
    },
    /* all */ addresses: state => state.addresses,
    addressMap: state => state.addressMap,

    // quantities of each catalog item for each cart position
    qtys: state => {
        var output = {};
        if (state.items.length > 0) {
            for (var itemIndex in state.items) {
                var position = state.items[itemIndex];
                if ('item_id' in position && position.item_id > 0) {
                    if ('children' in position /* && position.gc == false */) {
                        for (var itemId in position.children) {
                            var qty = +position.children[itemId];
                            // qty += this.getFreeKeepsakeCertCount(itemId);
                            if (qty > 0) {
                                if (!(itemIndex in output)) {
                                    output[itemIndex] = {};
                                }
                                output[itemIndex][itemId] = qty;
                            }
                        }
                    }
                }
            }
        }
        return output;
    },

    hasShippableItems: state => {
        var itemsCount = 0;
        var cart = state.items;
        if (cart.length > 0) {
            for (var itemIndex in cart) {
                var position = cart[itemIndex];
                if ('item_id' in position && position.item_id > 0) {
                    if ('gc' in position && position.gc === true) {
                        itemsCount++;
                    } else if ('children' in position) {
                        for (var itemId in position.children) {
                            var qty = +position.children[itemId];
                            itemsCount += qty;
                        }
                    }
                }
            }
        }
        return itemsCount;
    },

    // deliverable-to-shippingAddress mapping to be submitted to backend along with other order data
    shipItemTo: state => {
        var output = {};
        // debugger;
        for (var setIndex in state.items) {
            var set = state.items[setIndex];
            var itemId = 'item_id' in set ? set.item_id : false;
            var isGC = ('gc' in set) ? set.gc : false;
            var dataset = {
                qtys: []
            };
            if (isGC) {
                let k = [setIndex, itemId, 'g'].join('_');
                let addrId = state.billingAddressId;
                if (k in state.addressMap && state.addressMap[k] in state.addresses) {
                    // previous data input should be preserved
                    addrId = state.addressMap[k];
                }
                dataset.qtys.push({
                    item_id: itemId,
                    item_index: 'g',
                    address_id: addrId
                });
            } else {
                var qtys = set.children;
                for (let itemId in qtys) {
                    for (var i = 0; i < qtys[itemId]; i++) {
                        let k = [setIndex, itemId, i].join('_');
                        let addrId = state.billingAddressId;
                        if (k in state.addressMap && state.addressMap[k] in state.addresses) {
                            // previous data input should be preserved
                            addrId = state.addressMap[k];
                        }
                        dataset.qtys.push({
                            item_id: itemId,
                            item_index: i,
                            address_id: addrId
                        });
                    }
                }
            }
            if (dataset.qtys.length > 0) {
                output[setIndex] = dataset;
            }
        }
        return output;
    },

    // credit card related
    ccTypes: state => state.creditCard.types,
    ccMonthes: state => state.creditCard.monthes,
    ccYears: state => {
        var output = {};
        for (var i = 0; i < state.creditCard.yearsCount; i++) {
            var yr = (+state.creditCard.yearNow + i).toString();
            output[yr] = yr;
        }
        return output;
    },

    // related to calculations of specific amounts
    subTotal: state => {
        var sum = 0.0;
        var cart = state.items || {};
        for (var cartIndex in cart) {
            var lineItem = cart[cartIndex];
            var prodId = lineItem.item_id || 0;
            var product = state.catalog[prodId] || {};
            var basePrice = +(product.price || 0.0);
            sum += basePrice;
            for (var childId in cart[cartIndex].children || {}) {
                var qty = cart[cartIndex].children[childId];
                var price = +state.catalog[prodId].children[childId].price;
                sum += price * qty;
            }
        }
        return sum;
    },

    taxableAmount: state => {
        var taxable = 0.0;
        var cart = state.items || {};
        var products = state.catalog || {};
        // debugger;
        if (cart.length > 0) {
            for (var itemIndex in cart) {
                var position = cart[itemIndex];
                if ('item_id' in position) {
                    var productId = position.item_id;
                    if (productId in products) {
                        var product = products[productId];
                        if ('taxable_amount' in product) {
                            taxable += +product['taxable_amount'];
                        }
                        if ('children' in position) {
                            for (var itemId in position.children) {
                                var qty = +position.children[itemId];
                                // debugger;
                                if (itemId in product.children) {
                                    if ('taxable_amount' in product.children[itemId]) {
                                        taxable += qty * +product.children[itemId]['taxable_amount'];
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        taxable = +taxable.toFixed(2);
        return taxable;
    }
}

// actions
const actions = {
}

// mutation helpers
function toUpperCaseAll (campaign, lines) {
    let options = campaign.options || {};
    let inscription = options.inscription || {};
    let isAllUppercase = inscription.is_all_uppercase || false;
    if (isAllUppercase) {
        Object.keys(lines).map(function (key) {
            lines[key] = lines[key].toString().toUpperCase();
        });
    }
    return lines;
}

// mutations
const mutations = {
    // mobile navigation menu
    openExpander (state) {
        state.navExpanderOpen = true;
    },
    closeExpander (state) {
        state.navExpanderOpen = false;
    },

    initAllFromApi (state, { campaign, product, countries, states, yearNow, ccTypes }) {
        state.campaign = campaign || {};
        state.catalog = product || {};
        state.countries = countries || {};
        state.regions = states || {};
        state.creditCard.yearNow = yearNow;
        state.creditCard.types = ccTypes;
    },
    addItemToCart (state, item) {
        let campaign = state.campaign || {};
        let lines = item.lines || {};
        state.items.push(Object.assign(
            {}, item, { lines: toUpperCaseAll(campaign, lines) }
        ));
    },
    updateInscription (state, { cartId, lines }) {
        let campaign = state.campaign || {};
        let cart = state.items;
        if (cartId in cart) {
            cart[cartId].lines = toUpperCaseAll(campaign, lines);
            state.items = Object.assign([], cart);
        }
    },
    updatePreferredLocation (state, { cartId, location }) {
        let cart = state.items;
        if (cartId in cart) {
            if ('gc' in cart[cartId] && cart[cartId].gc === false) {
                cart[cartId].options = Object.assign({}, cart[cartId].options, { location: location });
                state.items = Object.assign([], cart);
            }
        }
    },
    deleteItemFromCart (state, index) {
        // to form new array without an element of old array with specified index
        state.items = state.items.filter(function (item, idx) {
            return idx !== index;
        });
    },
    changeItemQtyInCart (state, {itemIndex, childId, delta}) {
        var itemChildren = 'children' in state.items[itemIndex] ? state.items[itemIndex].children : {};
        var qty = childId in itemChildren ? itemChildren[childId] : -1;
        var newValue = qty + delta;
        if (newValue >= 0) {
            state.items[itemIndex].children[childId] = newValue;
        }
    },
    updateMarketingInfo (state, marketing) {
        state.marketing = marketing;
    },
    updateBillingAddress (state, billing) {
        if (state.billingAddressId in state.addresses) {
            state.addresses[state.billingAddressId] = billing;
        }
    },
    setShipToBilling (state) {
        state.shipTo = 'ship2billing';
        state.selectedAddressId = state.billingAddressId;
    },
    setAnotherAddress (state, address) {
        let addrId = +new Date();
        let addresses = state.addresses;
        addresses[addrId] = Object.assign({}, address, { address_id: addrId });
        state.addresses = Object.assign({}, addresses);
        state.shipTo = 'ship2another';
        state.selectedAddressId = addrId;
    },
    addNewAddress (state, address) {
        let addrId = +new Date();
        let addresses = state.addresses;
        addresses[addrId] = Object.assign({}, address, { address_id: addrId });
        state.addresses = Object.assign({}, addresses);
    },
    completeTheOrder (state, { order }) {
        state.orderId = order;
        state.isOrderCompleted = true;
    },
    clearCompletedOrder (state) {
        state.items = Object.assign([]);
        state.isOrderCompleted = false;
        state.orderId = 0;
    },
    populateAddressMap (state, shipItemTo) {
        var map = {};
        for (var setIndex in shipItemTo) {
            var qtys = shipItemTo[setIndex]['qtys'];
            for (var i = 0; i < qtys.length; i++) {
                if ('item_id' in qtys[i] && 'address_id' in qtys[i]) {
                    var itemId = qtys[i]['item_id'];
                    var itemIndex = qtys[i]['item_index'];
                    var k = [setIndex, itemId, itemIndex].join('_');
                    if ('address_id' in qtys[i]) {
                        map[k] = qtys[i]['address_id'];
                    }
                }
            }
        }
        state.addressMap = Object.assign({}, map);
        state.shipTo = 'ship2multiple';
        state.selectedAddressId = state.billingAddressId;
    }
}

/* eslint-disable no-new */
export default new Vuex.Store({
    state,
    actions,
    getters,
    mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js